import React from 'react';

const RecipesHeader = () => {
    return (
        <div>
            <h1>Recipes</h1>
        </div>
    );
};

export default RecipesHeader;
